<template>
  <div class="footer-link-column caption">
    <div class="column-header">
      <div class="header-icon">
        <img src="../assets/icons/arrow-right-black-extended.svg" alt="">
      </div>
      <div class="overline">{{$t('footer.sitemap')}}</div>
    </div>
    <router-link :to="{name: 'IndexPage'}" class="info-row">{{$t('footer.seu')}}</router-link>
    <router-link :to="{name: 'ChallengesPage', params: {slug: 'challenges', lang}}" class="info-row">{{$t('footer.challenges')}}</router-link>
    <router-link :to="{name: 'StrategyPage', params: {slug: getSlug('strategy'), lang}}" class="info-row">{{$t('footer.strategy')}}</router-link>
    <router-link :to="{name: 'OfferPage', params: {slug: getSlug('services'), lang}}" class="info-row">{{$t('footer.services')}}</router-link>
    <router-link :to="{name: 'FieldsPage', params: {slug: getSlug('engineering'), lang}}" class="info-row">{{$t('footer.engineering')}}</router-link>
    <router-link :to="{name: 'AboutUsPage', params: {slug: getSlug('about'), lang}}" class="info-row">{{$t('footer.about')}}</router-link>
    <router-link :to="{name: 'PostsPage'}" class="info-row">{{$t('footer.blog')}}</router-link>
    <router-link :to="{name: 'ContactUsPage', params: {slug: getSlug('contact'), lang}}" class="info-row">{{$t('footer.contact')}}</router-link>
  </div>
</template>
<script>
export default {
  name: "FooterLinkColumn",
  data: () => ({
    slugMap: {
      challenges: {
        DE: 'challenges',
        EN: 'challenges'
      },
      strategy: {
        DE: 'strategie',
        EN: 'strategy'
      },
      services: {
        DE: 'angebot',
        EN: 'services'
      },
      engineering: {
        DE: 'engineering',
        EN: 'engineering'
      },
      about: {
        DE: 'wir',
        EN: 'about'
      },
      contact: {
        DE: 'kontakt',
        EN: 'contact'
      }
    }
  }),
  computed: {
    lang() {
      if(this.$store.state.currentLanguage === this.$store.state.defaultLanguage) {
        return null
      }
      return this.$store.state.currentLanguage.toLowerCase()
    }
  },

  methods: {
    getSlug(page) {
      return this.slugMap[page][this.$store.state.currentLanguage]
    }
  }
}
</script>

<style lang="scss">
@import "FooterLinkColumn.scss";
</style>
